/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Summary_Status_Not_InvoicedInputs */



/**
* | output |
* | --- |
* | "Not yet invoiced" |
*
* @param {Partner_Summary_Status_Not_InvoicedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_status_not_invoiced = /** @type {((inputs?: Partner_Summary_Status_Not_InvoicedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Status_Not_InvoicedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht abgerechnet")
	return /** @type {LocalizedString} */ ("Not yet invoiced")
});